import Expander from '@/modules/Expander/Expander.js';
import Filter from './Filter.js';

const initExpander = (rootElement) => {
  const elements = Array.from(rootElement.querySelectorAll('[data-component="expander"]'));

  elements.forEach((element) => {
    new Expander(element, {
      shownClass: 'filter__options-list_shown',
      hiddenClass: 'filter__options-list_hidden',
    });
  });
};

const initFilter = () => {
  const element = document.querySelector('#filter');

  if (element) {
    new Filter(element);
  }
};

export default initFilter;
